import { useEffect, useState } from "react";
import { api_private_get, api_private_post, showAlert } from "script";

export default function AdminWithdrawalsTab() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);

  const fetchWithdrawals = () => {
    setLoading(true);
    api_private_get("/admin/withdrawals/pending", (data) => {
      setLoading(false);
      if (!data?.success) {
        showAlert(data?.error || "Unable to load withdrawals.", "danger");
        return;
      }
      setWithdrawals(data.withdrawals || []);
    });
  };

  useEffect(() => {
    api_private_get("/admin/withdrawals/pending", (data) => {
      setLoading(false);
      if (!data?.success) {
        showAlert(data?.error || "Unable to load withdrawals.", "danger");
        return;
      }
      setWithdrawals(data.withdrawals || []);
    });
  }, []);

  const processWithdrawal = (withdrawal, action) => {
    const verb =
      action === "complete"
        ? "mark this withdrawal completed"
        : "reject this withdrawal and return the funds";
    if (!window.confirm(`Confirm that you want to ${verb}?`)) return;

    setBusyId(withdrawal.tx_id);
    api_private_post(
      `/admin/withdrawals/${action}`,
      { tx_id: withdrawal.tx_id },
      (data) => {
        setBusyId(null);
        if (!data?.success) {
          showAlert(data?.error || "Unable to process withdrawal.", "danger");
          return;
        }
        showAlert(
          action === "complete"
            ? "Withdrawal completed."
            : "Withdrawal rejected and funds returned.",
          "success",
        );
        fetchWithdrawals();
      },
      () => {
        setBusyId(null);
        showAlert("Unable to process withdrawal.", "danger");
      },
    );
  };

  return (
    <div className="pay_method__tabletwo">
      <div className="d-flex justify-content-between align-items-center gap-3 mb-4">
        <h5 className="n10-color mb-0">Pending Interac withdrawals</h5>
        <button
          className="cmn-btn px-4 py-2"
          type="button"
          onClick={fetchWithdrawals}
          disabled={loading}
        >
          Refresh
        </button>
      </div>
      <div
        style={{ overflowX: "auto" }}
        className="pay_method__table-scrollbar"
      >
        <table className="w-100 text-center p2-bg">
          <thead>
            <tr>
              <th>Date</th>
              <th>User</th>
              <th>Email</th>
              <th>Requested CAD</th>
              <th>Transfer CAD</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading && withdrawals.length === 0 && (
              <tr>
                <td colSpan="6" className="py-6">
                  No pending Interac withdrawals.
                </td>
              </tr>
            )}
            {withdrawals.map((withdrawal) => (
              <tr key={withdrawal.tx_id}>
                <td className="text-nowrap">
                  {new Date(withdrawal.date).toLocaleString()}
                </td>
                <td>
                  <div>{withdrawal.user?.display_name}</div>
                  <small className="font-monospace">{withdrawal.user_id}</small>
                </td>
                <td>{withdrawal.user?.email}</td>
                <td className="text-nowrap">
                  ${Number(withdrawal.amount_usd).toFixed(2)} CAD
                </td>
                <td className="text-nowrap">
                  ${Number(withdrawal.amount_usd).toFixed(2)} CAD
                </td>
                <td>
                  <div className="d-flex justify-content-center gap-2 flex-wrap">
                    <button
                      className="cmn-btn px-3 py-2"
                      type="button"
                      disabled={busyId === withdrawal.tx_id}
                      onClick={() => processWithdrawal(withdrawal, "complete")}
                    >
                      Complete
                    </button>
                    <button
                      className="btn btn-danger px-3 py-2"
                      type="button"
                      disabled={busyId === withdrawal.tx_id}
                      onClick={() => processWithdrawal(withdrawal, "reject")}
                    >
                      Reject
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
